import { Link } from "react-router-dom";

const entries = [
  {
    title: "动漫资讯",
    desc: "行业动态、新番情报、产业观察，每天更新。",
    to: "/news",
    icon: "ri-newspaper-line",
    count: "3,600+ 篇",
  },
  {
    title: "作品库",
    desc: "TV 动画、剧场版、OVA，按类型与年份筛选。",
    to: "/works",
    icon: "ri-film-line",
    count: "1,280+ 部",
  },
  {
    title: "角色专题",
    desc: "从人物弧线到叙事功能，读懂角色的选择。",
    to: "/characters",
    icon: "ri-user-star-line",
    count: "480+ 篇",
  },
];

export default function ExploreBand() {
  return (
    <section aria-label="内容板块导览" className="w-full px-4 md:px-6 lg:px-10 pb-4">
      <div className="rounded-lg bg-accent-500 px-5 py-8 md:px-8 md:py-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-6">
          <div>
            <p className="text-[11px] tracking-[0.18em] text-accent-100 uppercase mb-2">EXPLORE</p>
            <h2 className="text-xl md:text-2xl font-bold text-background-50">从一个入口开始，认识 age动漫</h2>
          </div>
          <p className="text-sm text-accent-100 max-w-md leading-relaxed">
            我们不做信息堆砌，而是把值得读的内容整理成清晰的频道，让你按自己的节奏慢慢看。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
          {entries.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group rounded-md bg-background-50/10 border border-background-50/15 p-4 hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-50/15 text-background-50">
                  <i className={`${entry.icon} text-base`}></i>
                </span>
                <span className="text-[11px] text-accent-100">{entry.count}</span>
              </div>
              <h3 className="text-base font-semibold text-background-50 flex items-center gap-1.5">
                {entry.title}
                <i className="ri-arrow-right-up-line text-sm opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </h3>
              <p className="mt-1.5 text-xs text-accent-100/90 leading-relaxed">{entry.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}